import Cookies from 'js-cookie'

const TokenKey = 'ecare-shop-token'

export function getToken() {
    return Cookies.get(TokenKey)
}

export function setToken(token) {
    return Cookies.set(TokenKey, token)
}

export function removeToken() {
    return Cookies.remove(TokenKey)
}

export function getTokenByKey(TokenKey) {
    return Cookies.get(TokenKey)
}

export function setTokenByKey(TokenKey,token) {
    return Cookies.set(token)
}

export function removeTokenByKey(TokenKey) {
    return Cookies.remove(TokenKey)
}